import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';
import { theme } from '@sg/garnish';

import { useSocialLinks } from '../../hooks/useSocialLinks';
import { AccountMenuIconItem } from './AccountMenuIconItem';

export const AccountMenuIconRow = () => {
  const { formatMessage } = useIntl();
  const socialLinks = useSocialLinks(true);

  return (
    <View style={styles.iconItemsContainer}>
      <AccountMenuIconItem
        testID="account.menu.icon-item.instagram"
        label={formatMessage(messages.accountSidebarInstagram)}
        iconName="IconInstagram"
        onPress={socialLinks.handleInstagramTelemetry}
      />
      <AccountMenuIconItem
        testID="account.menu.icon-item.facebook"
        label={formatMessage(messages.accountSidebarFacebook)}
        iconName="IconFacebook"
        onPress={socialLinks.handleFacebookTelemetry}
      />
      <AccountMenuIconItem
        testID="account.menu.icon-item.tiktok"
        label={formatMessage(messages.accountSidebarTiktok)}
        iconName="IconTikTok"
        onPress={socialLinks.handleTiktokTelemetry}
      />
      <AccountMenuIconItem
        testID="account.menu.icon-item.twitter"
        label={formatMessage(messages.accountSidebarTwitter)}
        iconName="IconTwitter"
        onPress={socialLinks.handleTwitterTelemetry}
      />
      <AccountMenuIconItem
        testID="account.menu.icon-item.spotify"
        label={formatMessage(messages.accountSidebarSpotify)}
        iconName="IconSpotify"
        onPress={socialLinks.handleSpotifyTelemetry}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  iconItemsContainer: {
    marginTop: theme.spacing['2'],
    flexDirection: 'row',
    alignItems: 'center',
  },
});

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  accountSidebarInstagram: {
    defaultMessage: 'Instagram',
    description: 'Account | Sidebar | Instagram',
  },
  accountSidebarFacebook: {
    defaultMessage: 'Facebook',
    description: 'Account | Sidebar | Facebook',
  },
  accountSidebarTiktok: {
    defaultMessage: 'TikTok',
    description: 'Account | Sidebar | Tiktok',
  },
  accountSidebarTwitter: {
    defaultMessage: 'Twitter',
    description: 'Account | Sidebar | Twitter',
  },
  accountSidebarSpotify: {
    defaultMessage: 'Spotify',
    description: 'Account | Sidebar | Spotify',
  },
});
